import { memo } from 'react';

export const SettingsPage = memo(() => (
  <div>
    <h1>Settings</h1>
  </div>
));
